import React from 'react';

interface TicketAttachmentListProps {
  attachments?: Api.SupportTicket.AttachmentResponse[];
  title?: string;
}

export function TicketAttachmentList({ attachments, title = '相关附件' }: TicketAttachmentListProps) {
  if (!attachments || attachments.length === 0) return null;

  const formatFileSize = (bytes?: number) => {
    if (!bytes || bytes <= 0) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div className="mt-2.5 pt-2 border-t border-slate-200/60">
      {title && <span className="text-[11px] font-semibold text-slate-400 block mb-1.5">{title}</span>}
      <div className="flex flex-wrap gap-2">
        {attachments.map((att, idx) => {
          const isImage = att.mime_type?.startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/i.test(att.file_name || '');
          return (
            <a
              key={att.id || idx}
              href={att.access_url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white border border-slate-200 hover:border-emerald-500 hover:text-emerald-700 text-xs text-slate-700 transition-all shadow-2xs group"
            >
              <i className={isImage ? "ri-image-line text-emerald-600" : "ri-file-3-line text-slate-400"}></i>
              <span className="max-w-[140px] truncate font-medium">{att.file_name || '附件'}</span>
              {att.file_size ? (
                <span className="text-[10px] text-slate-400 group-hover:text-emerald-600">
                  {formatFileSize(att.file_size)}
                </span>
              ) : null}
              <i className="ri-external-link-line text-[11px] text-slate-400 group-hover:text-emerald-600"></i>
            </a>
          );
        })}
      </div>
    </div>
  );
}
